import Toast, { ToastShowParams } from 'react-native-toast-message';

export enum ToastTypeEnum {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Info = 'Info',
}

class ToastService {
  show(params: ToastShowParams) {
    Toast.show(params);
  }

  showSuccess(title: string, description?: string) {
    this.show({
      type: ToastTypeEnum.Success,
      props: { title, description },
    });
  }

  showError(title: string, description?: string) {
    this.show({
      type: ToastTypeEnum.Error,
      props: { title, description },
    });
  }

  showWarning(title: string, description?: string) {
    this.show({
      type: ToastTypeEnum.Warning,
      props: { title, description },
    });
  }

  showInfo(title: string, description?: string) {
    this.show({
      type: ToastTypeEnum.Info,
      props: { title, description },
    });
  }
}

export default new ToastService();
